import { Callout } from '@scale/scaleui-radix';
import type { HubstaffMemberActionsContext } from '@scale/genai-compass-shared/cards/hubstaff_member_actions';
import type { Column } from '@scale/compass-shared/types';

interface ConfigurationSummaryProps {
  context: HubstaffMemberActionsContext;
  availableColumns: Column[];
}

export default function ConfigurationSummary({
  context,
  availableColumns,
}: ConfigurationSummaryProps) {
  if (!context.hubstaffProjectId || !context.action || !context.userIdentifierColumn) {
    return null;
  }

  const selectedColumn = availableColumns.find(c => c.id === context.userIdentifierColumn);

  return (
    <Callout.Root color="green" size="1">
      <Callout.Text>
        <strong>Configuration Summary:</strong>
        <br />
        Project ID: {context.hubstaffProjectId}
        <br />
        Action: {context.action}
        <br />
        Identity Type: {context.userIdentityType}
        <br />
        Column: {selectedColumn?.header || context.userIdentifierColumn}
        {context.memberRole && (
          <>
            <br />
            Role: {context.memberRole}
          </>
        )}
        {context.timeTracking && (
          <>
            <br />
            Time Tracking: {context.timeTracking}
          </>
        )}
      </Callout.Text>
    </Callout.Root>
  );
}
